
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stations/[slug]/playlist",
      function () {
        return require("private-next-pages/stations/[slug]/playlist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stations/[slug]/playlist"])
      });
    }
  